/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IPage } from "../../models/UserGroups/UserGroupsContract";

export const pageNumber: number = 1;
export const pageSize: number = 50;
export const pageData: IPage = {
    pageNumber,
    pageSize
};
export const USER_GROUPS = 'User Groups';
export const EMPTY_SCREEN_TITLE = 'User Groups are optional. Add a User Group to assign roles to multiple users at once.';
export const ADD_USER_GROUP = "Add User Group";
export const SEARCH_USER_GROUP = 'Search Group (Min. 3 chars)';
export const NO_USER_GROUP_MESSAGE = "You Don't have Permission to Add User Group, Please contact your administrator";
export const LABELS_ROLES = {
    GROUP_NAME: 'Name',
    ROLES: 'Roles',
};
export const EMAIL = 'Email';
export const MAX_REQUEST_ITEMS = 500;
export const MAX_SELECTED_USERS_WARNING = 'You can add up to 500 users to a user group at a time.';
export const ADD_USERS = 'Add Users';
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const USERS_TITLE = 'Users';
export const SHOW_SELECTED_USERS = 'Show selected users';
export const DELETE_USER_CONTENT = 'Are you sure you want to delete ';
export const DELETE_USER = 'Delete User';
export const DELETE_USERS = 'Delete {0} Users';
export const DELETE_USER_FROM_GROUP = 'Delete user from group';
export const RESET = 'Reset';
export const CANCEL = 'Cancel';
export const SAVE = 'Add Users';
export const SAVE_AND_EXIT = 'Save & exit';
export const EMPTY_SCREEN_TITLE_USERS = 'Add a User to current group';
export const NEXT = 'Next';

export const ERROR_FETCHING_USER_GROUPS = 'Error fetching user groups ';
export const USER_GROUPS_DELETE_SUCCESS_MESSAGE = 'User was successfully deleted from';
export const ADD_USER_TO_GROUP_ERROR = 'Error while adding user to group: ';
export const USER_SAVED_SUCCESS_MESSAGE = 'Users have been saved successfully';
export const NA = '--';